import { Component, h, Prop, Host } from '@stencil/core';
import { ProductGenericItem, ProductWeightGroupListItem } from '../pn-proxio-pricegroup/types';

@Component({
  tag: 'pn-proxio-productcard-information',
  styleUrl: 'pn-proxio-productcard-information.scss',
})
export class PnProxioProductcardInformation {
  @Prop() label: string;
  @Prop() information: ProductGenericItem[] = [];

  render() {
    return (
      <Host>
        <div class="cardinfocontent">
          {this.information && this.information.length > 0 && this.label ? (
            <div class="cardinfocontent-item">
              {this.label ? (
                <p class="cardinfocontent-title">
                  <strong>{this.label}</strong>
                </p>
              ) : null}
              {this.information.map(item =>
                item ? (
                  <p>
                    <strong class="cardinfocontent-label">{item.item1}:</strong> {item.item2}
                  </p>
                ) : null,
              )}
            </div>
          ) : null}
        </div>
      </Host>
    );
  }
}
